import { MarketLayoutStylesSchema } from './MarketLayout.styles';

export const matchDetailsStyles: MarketLayoutStylesSchema = {
  headerText: {
    flex: '1',
    align: 'center',
    fontSize: '2xs',
    fontWeight: 'bold',
  },

  rowWrapper: {
    px: '4',
    py: '2',
    alignItems: 'center',
    display: 'flex',
    fontSize: 'xs',
    fontWeight: 'bold',
    justifyContent: 'space-between',
    borderTopWidth: undefined,
    gap: '2',
    pos: 'relative',
    color: 'gray.700',
    borderColor: 'blackAlpha.400',
    borderBottomWidth: '1px',
    boxShadow: '0 1px rgba(255, 255, 255, .07)',
    w: 'full',
  },
  rowWrapperFirst: {
    borderTopWidth: '1px',

    _before: {
      display: 'none',
    },
  },
  rowWrapperWithBtn: {
    pt: '2',
  },

  tab: {
    bg: 'alpha.300',
    borderBottom: '1px',
    borderColor: 'white',
    borderBottomColor: 'white',
    color: 'white',
    fontSize: '2xs',
    fontWeight: 'bold',
    _notFirst: { borderLeftWidth: '1px' },
    _selected: {
      bg: 'alpha.800',
      borderBottomColor: 'transparent',
      color: 'white',
    },
  },
};
